import React from "react";
import "./WelcomeSection.css";

// ✅ Import Video (LOCAL FILE)
import welcomeVideo from "../../Assets/videos/journeyman.mp4";

const WelcomeSection = () => {
  return (
    <section className="welcome-section">
      {/* LEFT: Video */}
      <div className="welcome-left">
        <video
          className="welcome-video"
          autoPlay
          loop
          muted
          playsInline
        >
          <source
            src={welcomeVideo}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div className="welcome-video-overlay"></div>
      </div>

      {/* RIGHT: Content */}
      <div className="welcome-right">
        <span className="welcome-label">THE JOURNEY BEGINS</span>

        <h2 className="welcome-title">JOURNEYMAN</h2>

        <p className="welcome-text">
          In a world where leaders are expected to navigate constant change,
          make impactful decisions, and inspire transformation, the greatest
          journey is often the one within.
        </p>

        <p className="welcome-text">
          <strong>JOURNEYMAN – The Music Within</strong> is not just a musical
          theatre production; it is an introspective odyssey. One that invites
          you to pause, reflect, and reconnect with the essence of who you are —
          finding <span className="highlight">BALANCE</span> beyond the roles
          you play.
        </p>
      </div>
    </section>
  );
};

export default WelcomeSection;